module.exports = __webpack_public_path__ + "static/media/LINE_APP.414687b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/LINE_APP.png
// module id = 2141
// module chunks = 0